export default {
  "addUser.header": "Add User",
  "addUser.headerButtonLabel": "Add User",
  "addUser.submitButtonLabel": "Add User",
  "addUser.maxUserExceeded": "Max user number reached for this plan.",
  "addUser.domainError": "The email added has a invalid domain. Please check the email and try again."
};
